// extracted by mini-css-extract-plugin
module.exports = {"header-container":"header_header-container__1l8g6","logoWrapper":"header_logoWrapper__3rlw4"};